import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import InfoBar from '../InfoBar';

import BuildQuerySearch from './Components/BuildQuerySearch';
import BuildQueryStructureDrawing from './Components/BuildQueryStructureDrawing';
import BuildQueryHeading from './Components/BuildQueryHeading';

import './BuildQuery.custom.scss';
import './BuildQuery.theme.scss';

function BuildQuery(props) {
  const { initialize } = props;

  useEffect(() => {
    initialize();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="build-query">
      <section className="build-query__wrapper left-gutter right-gutter " id="main-content">
        <BuildQuerySearch {...props} />
        <div className="build-query__wrapper_separator typography-meta">AND</div>
        <BuildQueryStructureDrawing {...props} />
      </section>
      <BuildQueryHeading {...props} />
      <InfoBar />
    </div>
  );
}

BuildQuery.propTypes = {
  initialize: PropTypes.func.isRequired,
};

export default BuildQuery;
